import {Component, Input, ViewChild, ChangeDetectionStrategy} from "@angular/core";
import {ScanListTabComponent} from "./scan-list-tab/scan-list-tab.component";
import {ScanJobsTabComponent} from "./scan-jobs-tab/scan-jobs-tab.component";

@Component({
    selector: "app-scans",
    templateUrl: "./scans.component.html",
    styleUrls: ["./scans.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ScanListComponent {
    @ViewChild(ScanListTabComponent) scanListTab: ScanListTabComponent;
    @ViewChild(ScanJobsTabComponent) scanJobsTab: ScanJobsTabComponent;

    @Input() tab = "scans";

    get activeTab(): string {
        return this.tab === "jobs" ? "jobs" : "scans";
    }

    refresh() {
        if (this.activeTab === "scans") {
            this.scanListTab?.getData();
        } else {
            this.scanJobsTab?.getData();
        }
    }
}
